import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemManufacturabilitySelector =
  (bomItemId: string) => (state: RootAppState) => {
    const projectId = state.project.activeProject?.id

    if (bomItemId === projectId) {
      return {
        status: state.project.activeProject.manufacturableStatus,
        result: state.project.activeProject.manufacturableResult,
        isManufacturable: state.project.activeProject.isManufacturable,
      }
    }

    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'Assembly':
      case 'Row': {
        return {
          status: bomItem.manufacturableStatus,
          result: bomItem.manufacturableResult,
          isManufacturable: bomItem.isManufacturable,
        }
      }
    }

    return null
  }
